<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M31.42,5.74a2.13,2.13,0,0,1-.19,3.1L10.66,26.44a2.33,2.33,0,0,1-3,0L.77,20.58a2.14,2.14,0,0,1-.19-3.11,2.34,2.34,0,0,1,3.22-.18l5.34,4.57L28.2,5.56A2.34,2.34,0,0,1,31.42,5.74Z"
    />
    </svg>
